module.exports = __webpack_public_path__ + "img/product-2a.f9f79818.jpg";